export default __webpack_public_path__ + "static/media/numberSix.99bcc02c.svg";